import { AccordionContentComponent } from './content/accordion_content.component';
import { Type } from '@angular/core';

export interface AccordionItem {
  component: Type<AccordionContentComponent>;
  id: string;
  title: string;
  description: string;
  timeToComplete: number;
  active: boolean;
  data: any;
  nextItem: AccordionItem;
}

export class AccordionItemClass {

  private component: Type<AccordionContentComponent>;
  private id: string;
  private title: string;
  private description: string;
  private timeToComplete: number;
  private active: boolean;
  private data: any;
  private nextItem = null;

  constructor(component: Type<AccordionContentComponent>,
              id: string,
              title: string,
              description: string,
              timeToComplete: number,
              active = false,
              data?: any,
              nextItem?: AccordionItem) {
    this.component = component;
    this.id = id;
    this.title = title;
    this.description = description;
    this.timeToComplete = timeToComplete;
    this.active = active;
    this.data = data;
    this.nextItem = nextItem;
  }

  getTemplateUrl() {
    return this.component;
  }

  getId() {
    return this.id;
  }

  getTitle() {
    return this.title;
  }

  getDescription() {
    return this.description;
  }

  getTimeToComplete() {
    return this.timeToComplete;
  }

  isActive() {
    return this.active;
  }

  getData() {
    return this.data;
  }

  getNextItem(): AccordionItem {
    return this.nextItem;
  }

  setNextItem(nextItem: AccordionItem) {
    this.nextItem = nextItem;
  }

  setIsActive(isActive: boolean) {
    this.active = isActive;
  }

  getClass(): string {
    if (this.isActive()) {
      return this.getId() + 'Active';
    } else {
      return 'inactive';
    }
  }

}
